<template>
  <header class="header-global">
    <base-nav class="navbar-main" type effect="dark" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5 logo" to="/">
        <img src="img/followlogo.png" alt="logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <a href="#">
            <img src="img/followlogo.png" />
          </a>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <li>
          <router-link to="/aboutus" class="dropdown-item cl-primary"
            >About Us</router-link
          >
        </li>
        <li>
          <router-link to="/contactus" class="dropdown-item cl-primary"
            >Contact Us</router-link
          >
        </li>
        <li>
          <router-link to="/partner" class="dropdown-item cl-primary"
            >Partner with Us</router-link
          >
        </li>
        <li>
          <router-link to="/visa" class="dropdown-item cl-primary"
            >Visa</router-link
          >
        </li>
        <!-- <li>
          <router-link to="#" class="dropdown-item cl-primary">24/7 Support</router-link>
        </li> -->
      </ul>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li v-if="!isLoggedIn" :key="loginkey" class="nav-item ml-lg-4">
          <router-link to="/login" class="btn btn-neutral btn-icon">
            <span class="btn-inner--icon">
              <i class="fa fa-user mr-2"></i>
            </span>
            <span class="nav-link-inner--text">Login</span>
          </router-link>
        </li>
        <!-- <li  v-show="isLoggedIn" key="logouthead" class="nav-item ml-lg-4"> -->
        <li v-if="isLoggedIn" :key="loginkey2" class="nav-item ml-lg-4">
          <div class="hovermenu">
            <button class="dropbtn">Hi {{ usertext }}</button>
            <div class="hovermenu-content">
              <!-- <a href="https://hotellele.com/fcrm/panel">Dashboard</a> -->

              <!-- <a href="#myorders">My Bookings</a> -->
              <router-link to="/myorders">My Bookings</router-link>
              <!-- <a href="https://hotellele.com/fcrm/invoices">Invoices</a>
              <a href="https://hotellele.com/fcrm/proposals">Proposals</a> -->

              <!-- <a href="https://hotellele.com/fcrm/tickets">Support Tickets</a> -->

              <!-- <a href="https://hotellele.com/fcrm/quotes">Quotations</a> -->
              <router-link to="/profile">Profile</router-link>
              <a @click.prevent="logoutClick" href="#">Logout</a>
            </div>
          </div>
        </li>
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  name: "AppHeader",
  data() {
    return {
      isLoggedIn: false,
      showlogin: false,
      loginkey: Math.floor(Math.random() * 999) + 1,
      loginkey2: Math.floor(Math.random() * 999) + 1,
      usertext: "My Account",
    };
  },
  methods: {
    isLog() {
      return localStorage.getItem("loggedIn") == "yes";
    },
    logoutClick() {
      localStorage.setItem("loggedIn", "no");
      this.isLoggedIn = false;
      this.usertext = "Login";
      //this.$forceUpdate();
      //this.$set(this.isLoggedIn, false);

      location.reload(true);
      //window.location.href = "https://hotellele.com/fcrm/area/login/logoutuser";
    },
  },
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
  beforeCreate() {
    this.isLoggedIn = localStorage.getItem("loggedIn") == "yes";
    this.usertext = localStorage.getItem("name");
  },
  beforeMount() {
    this.isLoggedIn = localStorage.getItem("loggedIn") == "yes";
    this.usertext = localStorage.getItem("name");
  },
  mounted() {
    if (localStorage.getItem("name") !== null) {
      this.intervalid1 = setInterval(
        function () {
          //this.isLoggedIn = localStorage.getItem("loggedIn");
          this.loginkey = Math.floor(Math.random() * 1999) + 1;
          this.loginkey2 = Math.floor(Math.random() * 1999) + 1;
          this.isLoggedIn = localStorage.getItem("loggedIn") == "yes";
          this.usertext = localStorage.getItem("name");
        }.bind(this),
        3000
      );
    }

    this.$root.$on("loginevent", (data) => {
      this.isLoggedIn = data;
      this.usertext = localStorage.getItem("name");
      if (!data) {
        this.usertext = "Login";
      }
      this.$forceUpdate();
    });
    var isl = localStorage.getItem("loggedIn");
    if (isl) {
      this.isLoggedIn = true;
      this.usertext = localStorage.getItem("name");
    } else {
      this.isLoggedIn = false;

      this.usertext = "Login";
    }
  },
  created() {
    var something = function () {
      this.isLoggedIn = localStorage.getItem("loggedIn") == "yes";
      this.usertext = localStorage.getItem("name");
    }.bind(this);

    (this.loginkey = Math.random()),
      (this.loginkey2 = Math.random()),
      this.$root.$on("loginevent", (data) => {
        this.isLoggedIn = data;
        this.usertext = localStorage.getItem("name");
        if (!data) {
          this.usertext = "Login";
        }
        this.$forceUpdate();
      });
  },
};
</script>
<style>
.hidden {
  display: none !important;
}
.cl-primary {
  color: #083578 !important;
}
.navbar-main {
  background: #eef5ff;
}
.navbar-brand img {
  height: 90px !important;
}
::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background-color: #888585;
  border: 1px solid #555555;
}
.dropbtn {
  background-color: #ffffff;
  color: #5e72e4;
  padding: 16px;
  font-size: 16px;
  border: none;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
}

.hovermenu {
  position: relative;
  display: inline-block;
}

.hovermenu-content {
  display: none;
  position: absolute;
  background-color: #ffffff;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  font-size: 1.3rem;
}

.hovermenu-content a {
  color: black;
  padding: 5px 16px;
  text-decoration: none;
  display: block;
  font-size: 0.9rem;
}

.hovermenu-content a:hover {
  background-color: #ddd;
}

.hovermenu:hover .hovermenu-content {
  display: block;
}

.hovermenu:hover .dropbtn {
  background-color: #ffffff;
}
.navbar-toggler-icon {
  /* background-color: #083578!important; */
  color: brown !important;
  border-radius: 0.3em;
  filter: invert(19%) sepia(68%) saturate(4700%) hue-rotate(189deg)
    brightness(87%) contrast(102%);
}
.dropdown-item{
  font-size: 1rem !important;
  font-weight: 700 !important;
}
.dropdown-item:hover, .dropdown-item:focus{
  background: transparent !important;
    color: #f7dc69 !important;
    border-bottom: 1px solid #083578;
}
.dropdown-item.active, .dropdown-item:active{
  background: transparent !important;
    color: #f7dc69 !important;
    border-bottom: 1px solid #083578;
}
.logo{
  cursor: pointer;
}
@media (max-width: 991.98px) {
  .navbar-collapse {
    margin: 0 0.7rem 0.7rem 0.7rem !important;
  }
  .navbar-collapse.collapsing,
  .navbar-collapse.show {
    top: 0.5rem;
  }
  button:focus{
    overflow: unset;
  }
}
</style>
